<div class="loading-spinner d-flex justify-content-center" *ngIf="loading">
  <div class="spinner-outer"  role="status">
      <img src="/assets/images/loader.gif">
    <span class="sr-only">Loading...</span>
  </div>
</div>
